import map_diff from '../base/map_diff'
import value_diff from '../base/value_diff'

const row_diff = map_diff(value_diff(), true)

export default row_diff
